import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, Res, NotificationData, UserInfo } from 'src/app/models';
import { LanguageService, ApiNotificationsService, ApiUsersService } from 'src/app/services';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.css']
})
export class NotificationsListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  notifications: NotificationData[] = [];
  // notifications: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  emailNotificationsState: boolean;

  constructor(

    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiNotificationsService: ApiNotificationsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.getEmailNotificationState();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

  }

  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.notifications = [];

    this.setListParams();

    this.apiNotificationsService.getListNotifications(this.listParams).subscribe((response: Res) => {
      console.log("RESPONSE_LIST: ", response)

      if (response != null && response.result != null) {

        this.notifications = response.result.list;

        // for (let item of response.result.list) {

        //   item.notification_content = JSON.parse(item.notification_content);
        //   item.notification_content = item.notification_content.content.message;
        //   this.notifications.push(item);
        // }

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: '',
        sort: 'ALL'
      },
      object: 'notifications',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  // CHECKBOX
  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.notifications[index].checked = event.target.checked;
    // this.counterSelectedFiles();
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.notifications.forEach(x => x.checked = event.target.checked);

    // this.counterSelectedFiles();

    // this.storageForChekcedFiles();
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.notifications.length == 0) return false;

    return this.notifications.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.notifications.length;
    let pc = this.notifications.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.notifications.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


  /**
   * 
   */
  getEmailNotificationState() {

    this.apiNotificationsService.getEmailStateOfNotification().subscribe((response: Res) => {
      console.log("RESPONSE_NOTIFICATIONS: ", response)

      if (response != null && response.result != null) {

        this.emailNotificationsState = response.result.state;
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });

  }

  /**
   * 
   * @param event 
   */
  setEmailNotificationState(): void {

    let data = {
      state: this.emailNotificationsState
    }

    this.subscriptions.add(
      this.apiNotificationsService.setEmailStateOfNotification(data).subscribe((response: any) => {
        console.log("SET STATE: ", response);


        if (response != null) {


        }
      })
    );

  }



  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

}
